import React from 'react';
import './Collaboratori.css';
import { Ragazzo } from '../../services/api'; // Importa l'interfaccia Ragazzo

interface WidgetProps {
  onClose: () => void;
  ragazzi?: Ragazzo[] | null; // Array di collaboratori
  capogruppo?: Ragazzo | null; // Singolo capogruppo
  className?: string;
}

const Collaboratori: React.FC<WidgetProps> = ({ onClose, ragazzi, capogruppo, className }) => {
  return (
    <div className={`widget-card collaboratori-widget ${className || ''}`}>
      <div className="widget-header">
        <h3>Collaboratori e Orari</h3> {/* Titolo aggiornato */}
        <button onClick={onClose} className="widget-close-btn" aria-label="Chiudi widget Collaboratori">
          <i className="fas fa-times"></i>
        </button>
      </div>
      <div className="widget-content">
        {/* Sezione Orari Responsabile */}
        {capogruppo && (
          <div className="capogruppo-section">
            <div className="collaboratore-section-header">
              Orari <span className="header-note">(se diversi da uscita)</span>
            </div>
            <div className="collaboratore-row">
              <button className="action-button avvio">Avvio</button>
              <span className="collaboratore-name responsabile">{capogruppo.mob_dip_nome}</span>
              <button className="action-button si">Si</button>
              <button className="action-button fine">Fine</button>
            </div>
          </div>
        )}

        {/* Sezione Orari Collaboratori */}
        {ragazzi && ragazzi.length > 0 && (
          <div className="collaboratore-section">
            <div className="collaboratore-section-header">
              Orari <span className="header-note">(se diversi da uscita)</span>
            </div>
            <ul className="collaboratori-list">
              {ragazzi.map((ragazzo) => (
                <li key={ragazzo.mob_dip_id} className="collaboratore-row">
                  <button className="action-button avvio">Avvio</button>
                  <span className="collaboratore-name">{ragazzo.mob_dip_nome}</span>
                  <button className="action-button si">Si</button>
                  <button className="action-button fine">Fine</button>
                </li>
              ))}
            </ul>
          </div>
        )}

        {!capogruppo && (!ragazzi || ragazzi.length === 0) && (
          <p className="widget-message info">Seleziona un'uscita per visualizzare i collaboratori.</p>
        )}
         {capogruppo && (!ragazzi || ragazzi.length === 0) && (
          <p className="widget-message info">Nessun collaboratore aggiuntivo assegnato a questa uscita oltre al responsabile.</p>
        )}
      </div>
    </div>
  );
};

export default Collaboratori; 